import PropTypes from 'prop-types';
import React from 'react';
import { Box } from '@mui/material';
import { TextField } from '../../../Common/textfield.js';

function CKeditorpopupData({ data, setData, err, validateRecipient }) {
	const handleData = (value, name) => {
		setData((preValue) => ({ ...preValue, [name]: value }));
		const newData = { ...data, [name]: value };

		validateRecipient(newData);
	};

	return (
		<Box display={'flex'} flexDirection={'column'} rowGap={2.5} mt={3}>
			<TextField
				text='Name'
				type='text'
				handleInput={handleData}
				placeholder={'Name'}
				removeImageLeftBorder
				name={'name'}
				error={err.name}
				labelClassName={'medium7 dark-textcolor'}
			/>
			<TextField
				text='Mobile No'
				type='text'
				handleInput={handleData}
				placeholder={'Mobile No'}
				removeImageLeftBorder
				name={'mobileno'}
				error={err.mobileno}
				labelClassName={'medium7 dark-textcolor'}
			/>
			<TextField
				text='EmailId'
				type='text'
				handleInput={handleData}
				placeholder={'EmailId'}
				removeImageLeftBorder
				name={'email'}
				error={err.email}
				labelClassName={'medium7 dark-textcolor'}
			/>
		</Box>
	);
}

export default CKeditorpopupData;

CKeditorpopupData.propTypes = {
	data: PropTypes.any,
	setData: PropTypes.any,
	err: PropTypes.any,
	validateRecipient: PropTypes.any
};
